import { request } from '../lib/apiClient'

/** Unified global search — backend/search/app.py. Buckets capped 4/4/3 server-side. */

export function fetch({ q, limit } = {}) {
  return request('/search/fetch', { params: { q, limit } })
}
